const isWithinXMinutes = ({
  date,
  minutesMs,
}: {
  date: Date;
  minutesMs: number;
}) => {
  const now = new Date();
  const diff = now.getTime() - date.getTime();

  return diff <= minutesMs;
};

export default isWithinXMinutes;
